import './App.scss';
import {t} from "i18next";
import RegistrationForm from "./components/Form";
import {useRef, useState, useEffect} from "react";

function App() {

    const [appState, setAppState] = useState({state: 'form'});
    const [userInfo, setUserinfo] = useState(null);
    const [isPopupShowed, setShowed] = useState(false);
    const popupEl = useRef();

    useEffect(() => {
        function handleClickOutside(event) {
            if (popupEl.current && !popupEl.current.contains(event.target)) {
                // setShowed(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [popupEl]);

    const userRegisterHandler = (isUserRegister, userInfo) => {
        setUserinfo(userInfo)
        setAppState({state: 'success'})
    }

    const fatalErrorHandler = () => {
        setAppState({state: 'error'})
    }

    const closePopupHandler = () => setShowed(false)
    const openPopupHandler = () => setShowed(true)

    const display = isPopupShowed ? {display: ''} : {display: "none"};
    let a = "";
    switch (appState.state) {
        case "form":
            a = renderRegisterForm({
                userRegisterHandler: userRegisterHandler,
                closePopupHandler: closePopupHandler,
                fatalErrorHandler: fatalErrorHandler
            })
            break;
        case "success":
            a = renderSuccess({userInfo: userInfo, closePopupHandler: closePopupHandler})
            break;
        default:
            a = renderError({userInfo: userInfo, closePopupHandler: closePopupHandler})

    }

    return (
        <>
        <span onClick={openPopupHandler}  style={{display: "none"}} data-open_sign_up="">
        </span>
            <div className="popup__container" style={display}>
                <div className="popup__background">
                </div>
                <div className="popup" ref={popupEl}>
                    <div className="popup__border">
                        {a}
                    </div>
                </div>
            </div>
        </>
    );
}

function closeIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                  fill="#AFBDD1"/>
        </svg>
    )
}

function renderSuccess(props) {
    return (
        <>
            <div className="popup__header">
                <div>
                    <span>Confirm your email</span>
                </div>
                <div className="popup__close-container">
                    <span onClick={props.closePopupHandler} className="popup__close">
                        {closeIcon()}
                    </span>
                </div>
            </div>
            <div className="popup__content">
                <p className="success-text">
                    We are almost there! To start using iPNOTE, we need to confirm your identity. Click on the link that
                    we have sent to {props.userInfo.email}.<br/>
                </p>
                <p className="success-text">
                    The link is valid for only 7 days.<br/>
                </p>
                <p className="success-text">
                    If you couldn't find it, kindly check your spam folder for an email from support@ipnote.pro.
                </p>
                <button className="button" onClick={props.closePopupHandler}>Ok, Got it</button>
            </div>
        </>
    );
}

function renderError(props) {
    return (
        <>
            <div className="popup__header">
                <div>
                    <span>Error</span>
                </div>
                <div className="popup__close-container">
                    <span onClick={props.closePopupHandler} className="popup__close">
                        {closeIcon()}
                    </span>
                </div>
            </div>
            <div className="popup__content">
                <p className="success-text">
                    Please contact us at support@ipnote.pro
                </p>
                <button className="button" onClick={props.closePopupHandler}>Ok, Got it</button>
            </div>
        </>
    );
}

function renderRegisterForm(props) {
    let termsUrl = process.env.REACT_APP_TERMS_URL;
    let privacyUrl = process.env.REACT_APP_PRIVACY_URL;
    let loginUrl = process.env.REACT_APP_LOGIN_URL;

    return (
        <>
            <div className="popup__header">
                <div>
                    <span>{t("Sign up")}</span>
                </div>
                <div className="popup__close-container">
                    <span onClick={props.closePopupHandler} className="popup__close">
                        {closeIcon()}
                    </span>
                </div>
            </div>
            <div className="popup__content">
                <RegistrationForm
                    userRegisterSuccessHandler={props.userRegisterHandler}
                    fatalErrorHandler={props.fatalErrorHandler}
                />
            </div>
            <div className='popup-footer'>
                <p className='terms'>
                    By continuing, you agree to iPNOTE's <a target="_blank" rel="noreferrer" href={termsUrl}>Terms of
                    Use</a> and <a target="_blank"
                                   rel="noreferrer"
                                   href={privacyUrl}>Privacy
                    Policy.</a>
                </p>
                <p className="have-acc">
                    Have an account? <a target="_blank" rel="noreferrer" href={loginUrl}>Log in</a>
                </p>
            </div>
        </>
    );

}

export default App;
